(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["_saffron-countdown"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('ps-countdown')) {
    class PsCountdown extends HTMLElement {
      connectedCallback() {
        this._h = this.querySelector('[data-hours]');
        this._m = this.querySelector('[data-minutes]');
        this._s = this.querySelector('[data-seconds]');
        var endStr = this.getAttribute('data-end-date');
        this._end = endStr ? new Date(endStr).getTime() : Date.now() + 6 * 3600000;
        if (isNaN(this._end)) this._end = Date.now() + 6 * 3600000;
        this._tick();
        this._interval = setInterval(this._tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this._interval); }
      _tick() {
        var diff = Math.max(0, this._end - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (this._h) this._h.textContent = String(h).padStart(2, '0');
        if (this._m) this._m.textContent = String(m).padStart(2, '0');
        if (this._s) this._s.textContent = String(s).padStart(2, '0');
        if (diff === 0) clearInterval(this._interval);
      }
    }
    customElements.define('ps-countdown', PsCountdown);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["_saffron-form-buy"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('sf-countdown')) {
    class PsCountdown extends HTMLElement {
      connectedCallback() {
        this._h = this.querySelector('[data-hours]');
        this._m = this.querySelector('[data-minutes]');
        this._s = this.querySelector('[data-seconds]');
        var endStr = this.getAttribute('data-end-date');
        this._end = endStr ? new Date(endStr).getTime() : Date.now() + 6 * 3600000;
        if (isNaN(this._end)) this._end = Date.now() + 6 * 3600000;
        this._tick();
        this._interval = setInterval(this._tick.bind(this), 1000);
      }
      disconnectedCallback() { clearInterval(this._interval); }
      _tick() {
        var diff = Math.max(0, this._end - Date.now());
        var h = Math.floor(diff / 3600000);
        var m = Math.floor((diff % 3600000) / 60000);
        var s = Math.floor((diff % 60000) / 1000);
        if (this._h) this._h.textContent = String(h).padStart(2, '0');
        if (this._m) this._m.textContent = String(m).padStart(2, '0');
        if (this._s) this._s.textContent = String(s).padStart(2, '0');
        if (diff === 0) clearInterval(this._interval);
      }
    }
    customElements.define('sf-countdown', PsCountdown);
  }
  } catch(e) { console.error(e); }
})();

})();
